import React from 'react';
import { PageFooterTemplate } from 'themes/layouts';

function PageFooter(props) {
    return <PageFooterTemplate {...props} />;
}

export default PageFooter;
